import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';
import Seo from './Seo';
import Topbar from './Topbar';

const NotFound = () =>{
    const { t } = useTranslation();
    const location = useLocation();

    return(
        <>
            <Seo
                title={`${t('pagenotfound')} | IGGI`}
                description={t('pagenotfound')}
                path={location.pathname}
                noindex
            />
            <Topbar />
            <main className="notFound">
                <h1>{ t('pagenotfound') }</h1>
            </main>
            <Footer />
        </>
    )
}

export default NotFound;
